// removed by extract-text-webpack-plugin
module.exports = {"Modal":"-name__-loca-__32_-a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 174
// module chunks = 0